const searchTypeMap = {
  hospital_affiliation_ids: 'name',
  group_affiliation_ids: 'name',
};

export default searchTypeMap;
